import axios from 'axios'

import { Routes } from '~/api/api-routes'

import themeStore, { setDark, setGolden,setLight } from '~/plugins/themestore'

export default {
  namespaced: true,
  state: {
    sumaiSupplierId: 13,
    countries: null,

    // >>> current user info
    creditNotRedeemedAmount: null,
    ordersCountInfo: null,
    // <<<
    printfulNavCategories: undefined,
    fetchingCategories: false,
    printfulCategoryProducts: undefined,

    iconCache: {},
    isMobile: false,
    activeTheme: localStorage.getItem('activeTheme') || 'light',
  },
  getters: {
    activeTheme: (state) => state.activeTheme,
    _currentTheme: () => themeStore.type, //TODO: remove. move everyhing to vuex
    _isDarkSurface: () => ['dark', 'golden'].includes(themeStore.type),
    _sumaiSupplierId: (state) => state.sumaiSupplierId,
    _countries: (state) => state.countries ?? [],
    _creditNotRedeemedAmount: (state) => state.creditNotRedeemedAmount,
    _ordersCountInfo: (state) => state.ordersCountInfo,
    printfulNavCategories: (state) => state.printfulNavCategories,
    iconCache: (state) => state.iconCache,
    isMobile: (state) => state.isMobile,
    getPrintfulCategoryProducts: (state) => state.printfulCategoryProducts,
    getFetchingCategories: (state) => state.fetchingCategories,
  },
  mutations: {
    _setCountries(state, countries) {
      state.countries = countries
    },

    setPrintfulCategories(state, categories) {
      const modCategories = categories
      modCategories.forEach((category) => {
        if (!category.hasOwnProperty('children')) {
          category.children = []
        }
      })
      state.printfulNavCategories = modCategories
    },

    setActiveTheme(state, theme) {
      const validThemes = ['dark', 'light', 'golden', 'device']
      if (!validThemes.includes(theme)) return

      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'

      const themeToApply = theme === 'device' ? systemTheme : theme

      if (theme === 'golden') {
        document.documentElement.setAttribute('data-theme', 'golden')
        localStorage.setItem('activeTheme', theme)
        state.activeTheme = theme
        setGolden()
        return
      }

      document.documentElement.setAttribute('data-theme', themeToApply)
      themeToApply === 'dark' ? setDark() : setLight()

      localStorage.setItem('activeTheme', theme)
      state.activeTheme = theme
    },

    cacheIcon(state, data) {
      state.iconCache[data.path] = data.icon
    },

    setIsMobileState(state, isMobile) {
      state.isMobile = isMobile
    },

    setCategoryProducts(state, products) {
      state.printfulCategoryProducts = products
    },

    setFetchingCategories(state, value) {
      state.fetchingCategories = value
    },
  },
  actions: {
    async _loadOrdersCountInfo({ state }) {
      // temporary ability to disable if face problems
      if (!window.config.count_orders_enabled) return Promise.resolve()

      let answer = await axios.get(Routes.order.getOrdersCount())

      state.ordersCountInfo = {
        ordersUnpaidCount: answer.data.ordersUnpaidCount,
        ordersLinkProductCount: answer.data.ordersLinkProductCount,
        ordersWithIssuesCount: answer.data.ordersWithIssuesCount,
      }

      return state.ordersCountInfo
    },

    async _loadCountries({ state, commit }) {
      if (!state.countries) {
        let answer = await axios.get(Routes.other.getCountries)
        commit('_setCountries', answer.data)
      }

      return state.countries
    },

    async _loadCreditNotRedeemedAmount({ state }) {
      const storeId = localStorage.getItem('activeStore')
      let answer = await axios.get(Routes.userProfile.getUserCredit, storeId ? { params: { storeId } } : undefined)
      state.creditNotRedeemedAmount = answer.data.toFixed(2)

      return state.creditNotRedeemedAmount
    },

    async setPrintfulCategories({ state, commit }, payload) {
      commit('setPrintfulCategories', payload)
      commit('setFetchingCategories', false)

      return state.printfulNavCategories
    },
  },
}
